import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const HamburgerMenu = ({
  expandMenu,
  onClick
}) => (
  <button
    type="button"
    className={`${styles.toggleButton} ${expandMenu ? styles.closeButton : ''}`}
    onClick={onClick}
  >
    <span className={styles.screenReaderOnly}>Toggle navigation</span>
    <span className={styles.iconBar} />
    <span className={styles.iconBar} />
    <span className={styles.iconBar} />
    <span className={styles.iconBar} />
  </button>
);

HamburgerMenu.propTypes = {
  expandMenu: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default HamburgerMenu;
